import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const AeoCatalogOptimizationItem = memo(
  function AeoCatalogOptimizationItem() {
    const { t } = useTranslation();
    const routes = useRequiredContext(MerchantRoutesContext);
    const urlPrefix = `${routes.aeoCatalogHref}/optimization`;
    const isSelected = useMatch(`${urlPrefix}/*`);

    return (
      <RedoSecondaryNavItem
        action={{ type: "link", href: urlPrefix }}
        anyChildSelected={!!isSelected}
        friendlyName={t("Optimization", {
          context:
            "AI engine optimization navigation label for catalog content optimization",
        })}
        id="aeo-catalog-optimization"
      />
    );
  },
);
